import { SatelliteEntity } from '@shared/types'

export const SHEET_CORE_SECTIONS_BEFORE_OPS = 'coreSectionsBeforeOps'
export const SHEET_CORE_SECTIONS_AFTER_OPS = 'coreSectionsAfterOps'
export const PACKAGING_CORE_TABLE_NAME = 'packaging_data_core' as const
export const OPERATION_INDICATOR = 'operation' as const
export const CORE_SECTION_INDICATOR = 'core' as const
export const SECTION_MULTI_LABEL_NAME = 'multiLabel' as const
export const HEADER_TABLE_NAME = 'header_core' as const
export const OUTSOURCE_TABLE_NAME = 'outsource_operation' as const
export const JOB_DESCRIPTION_TABLE_NAME = 'job_description_core' as const
export const CUSTOMER_NOTES_TABLE_NAME = 'customer_notes_core' as const
export const FINAL_TABLE_NAME = 'final_core' as const
export const INFORMATION_TABLE_NAME = 'information_core' as const
export const SHEET_TABLE_NAME = 'sheet' as const
export const OPERATIONS_TABLE_NAME = 'operations' as const
export const OPERATIONS_CONFIG_TABLE_NAME = 'operation_config' as const
export const ESTIMATE_TIME = 'estimateTime' as const
export const ESTIMATE_TIME_TABLE_NAME = 'operations_estimate_time' as const
export const ATTRIBUTE_MULTI_PREFIX = 'multi_' as const
export const SECTION_LABEL_NAME = 'label' as const
export const SECTION_POSITION_NAME = 'position' as const
export const MATERIAL_SHAPE_NAME = 'multi_shape' as const
export const SHEET_ID_NAME = 'sheetId' as const
export const OPERATION_ID_NAME = 'firstOperationAttributeId' as const
export const IS_DELETED_FLAG_NAME = 'isDeleted' as const
export const DELETED_INDICATOR = 'deleted' as const
export const WORKSTATION_ATTRIBUTE_NAME = 'workStation' as const
export const MATERIAL_ATTRIBUTE_NAME = 'materialType' as const
export const IS_RAW_MATERIAL_NEEDED_ID = 'rawMaterialNeeded' as const
export const MATERIAL_CORE_TABLE_NAME = 'material_core' as const
export const PARTIAL_SHIPMENT_ATTRIBUTE_NAME = 'partialShipment' as const
export const RECORD_TYPE_NAME = 'recordType' as const
export const ATTRIBUTE_UNIT_SUFFIX = '_unit' as const
export const ATTRIBUTE_YIELD_PREFIX = 'yield_' as const
export const TOTALS_TABLE_NAME = 'totals_core' as const
export const COC_REQUIRED = 'isCocRequired' as const
export const COC_ADDITIONAL_DATA = 'cocAdditionalData' as const
export const PHOTO_DRAWINGS_ATTRIBUTE = 'drawings' as const
export const PHOTO_URL = 'url' as const
export const INSPECTION_DATA_TABLE_NAME = 'inspection_data_core' as const
export const INSPECTION_DATA_HAS_DATA_ID = 'hasData' as const
export const SIGNATURE_ATTRIBUTE_NAME = 'signature' as const
export const CUSTOMER_REPORT_SECTION_LABEL_SUFFIX = ' - Will be included in Customer report' as const
export const MUST_AVOID_SHIFTING_ATTRIBUTE = 'mustAvoidShifting' as const
export const MUST_BE_SEALED_ATTRIBUTE = 'mustBeSealed' as const
export const CUSTOMER_REPORT_REQUIRED_ID = 'isCustomerReportRequired' as const
export const CUSTOMER_REPORT_NOT_REQUIRED_REASON_ID = 'customerReportNotRequiredReason' as const

export const YIELD_FIELDS = Object.freeze([
	`${ATTRIBUTE_YIELD_PREFIX}partsRequiredPerAssembly`,
	`${ATTRIBUTE_MULTI_PREFIX}${ATTRIBUTE_YIELD_PREFIX}partsAccepted`,
	`${ATTRIBUTE_MULTI_PREFIX}${ATTRIBUTE_YIELD_PREFIX}partsRejected`,
	`${ATTRIBUTE_MULTI_PREFIX}${ATTRIBUTE_YIELD_PREFIX}operator`,
] as const)

export const YieldField = Object.freeze({
	PARTS_REQUIRED_PER_ASSEMBLY: YIELD_FIELDS[0],
	PARTS_ACCEPTED: YIELD_FIELDS[1],
	PARTS_REJECTED: YIELD_FIELDS[2],
	OPERATOR: YIELD_FIELDS[3],
} as const)

export const SHAPE_ATTRIBUTES = [
	'multi_shape',
	'multi_width',
	'multi_width_unit',
	'multi_thickness',
	'multi_thickness_unit',
	'multi_length',
	'multi_length_unit',
	'multi_od',
	'multi_od_unit',
	'multi_id',
	'multi_id_unit',
	'multi_wt',
	'multi_wt_unit',
] as const

export const SYSTEM_COLUMNS = Object.freeze(['createdAt', 'updatedAt', 'id'] as const)
export const SECTION_COLUMNS_TO_OMIT = Object.freeze([
	...SYSTEM_COLUMNS,
	SECTION_MULTI_LABEL_NAME,
	IS_DELETED_FLAG_NAME,
	SECTION_LABEL_NAME,
	SHEET_ID_NAME,
	SECTION_POSITION_NAME,
	RECORD_TYPE_NAME,
	PHOTO_DRAWINGS_ATTRIBUTE,
	OPERATION_ID_NAME,
	PHOTO_URL,
	'sanitizedCustomer',
	'sanitizedPartNumber',
] as const)
/**
 * Keys are attribute names, values are table names
 */
export const SATELLITE_TABLE_NAMES = new Map<string, SatelliteEntity>([
	[MATERIAL_ATTRIBUTE_NAME, SatelliteEntity.MATERIAL_TYPE],
	['site', SatelliteEntity.SITE],
	[WORKSTATION_ATTRIBUTE_NAME, SatelliteEntity.WORK_STATION],
	['engineer', SatelliteEntity.ENGINEER],
])

export const LONG_TEXT_CHARS = 4096 as const
export const MEDIUM_TEXT_CHARS = 1024 as const
export const SHORT_TEXT_CHARS = 255 as const
/* Depends of the Decimal declaration in the db, for (14,4) -> 10 whole */
export const DECIMAL_WHOLE_MAX_LENGTH = 10 as const
export const DECIMAL_MAX_LENGTH = 4 as const

export const SHEET_LONG_TEXT_FIELD_MAX_ROWS = 6 as const
export const SHEET_LONG_TEXT_FIELD_DEFAULT_ROWS = 2 as const

export const SIGNATURE_FIELD_PLACEHOLDER_TEXT = '[Signature Field]' as const

export const DISPLAY_JOB_FILTERS = 'displayJobFilters' as const
